import styled from '@emotion/styled';
import React from 'react';
import { TestId } from '@components/test-ids';
import { Theme } from '@theme/base';
import { DestinationsNavContent } from './DestinationsNavContent';
import { SelectedOptions, SetOptions } from './NavBar';
import { HereToHelpNavContent } from './HereToHelpNavContent';
import { ContentTypes } from '@model/navigation';
import { NavDestinations, PageData } from '@model/content';
import { OffersNavContent } from './OffersNavContent';

/* ***************** *
 *       Types       *
 * ***************** */
export interface DesktopNavigationContentProps {
  theme?: Theme;
  testId?: string;
  navContent: ContentTypes;
  navDestinations: NavDestinations | null;
  navOffers: Array<PageData>;
  navInfo: Array<PageData>;
  selectedOptions: SelectedOptions;
  setOptions: SetOptions;
  onToggleDesktopNav?: () => void;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const DesktopContentContainer = styled.div({
  display: 'flex',
  minHeight: '100%',
  a: {
    textDecoration: 'none'
  }
});

/* ****************************** *
 *    DesktopNavigationContent    *
 * ****************************** */

export const DesktopNavigationContentComponent = (props: DesktopNavigationContentProps) => {
  const { navContent, selectedOptions, setOptions, onToggleDesktopNav, navDestinations, navOffers, navInfo } = props;

  /* *** RENDERERS *** */
  const renderContent = () => {
    switch (navContent) {
      case ContentTypes.OFFERS:
        return <OffersNavContent offerPages={navOffers} onToggleDesktopNav={onToggleDesktopNav} />;
      case ContentTypes.DESTINATIONS:
        return (
          <DestinationsNavContent
            destinations={navDestinations}
            selectedOptions={selectedOptions}
            setOptions={setOptions}
            onToggleDesktopNav={onToggleDesktopNav}
          />
        );
      case ContentTypes.HERE_TO_HELP:
        return <HereToHelpNavContent infoPages={navInfo} onToggleDesktopNav={onToggleDesktopNav} />;
      default:
        return null;
    }
  };

  return (
    <DesktopContentContainer data-testid={props.testId || TestId.desktopNavigationContent.main}>
      {renderContent()}
    </DesktopContentContainer>
  );
};
